import React from 'react';
import { Outlet } from 'react-router-dom';
import { initiateLogin } from './authentication';

async function login() {
  await initiateLogin();
}

export default function PrivateRoute({
  isAuthenticated,
}: any) {
  if (!isAuthenticated) {
    login();
    return null;
  }

  return <Outlet />;
}